module.exports = global["jQuery"] = require("-!/home/wevercbj/staging.weverducre.com/www/node_modules/expose-loader/index.js?$!./jquery.js");